import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState('light');
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // 1. Check localStorage first
    const saved = localStorage.getItem('theme-preference');
    if (saved && ['light', 'dark'].includes(saved)) {
      setTheme(saved);
      applyTheme(saved);
      setIsInitialized(true);
      return;
    }

    // Default to light for first-time users. Dark mode is opt-in via the toggle.
    setTheme('light');
    applyTheme('light');

    setIsInitialized(true);
  }, []);

  const applyTheme = (themeName) => {
    const html = document.documentElement;
    html.setAttribute('data-theme', themeName);
    html.style.colorScheme = themeName;
  };

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme-preference', newTheme);
    applyTheme(newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isInitialized }}>
      {children}
    </ThemeContext.Provider>
  );
}
